import { call, put, takeLatest } from 'redux-saga/effects';

import { actions } from '@tvguide/store/actions/requests';
import { setChannels } from '@store/actions/channels';
import API from '@api';

function* fetchChannels(action) {
  try {
    const channels = yield call(API.getChannels.bind(API), action.nid);
    yield put(setChannels(channels));
  } catch (e) {}
}

function* channelSaga() {
  yield takeLatest(actions.channels, fetchChannels);
}

export default channelSaga;
